<template>
    <div>
        <div v-if='route == "itim_shop"' class='itim-shop-container'>
            <Header v-show='show_top_navigation' :updated_cart_watcher='updated_cart_watcher' @updatedCartListener='updatedCartListener'  :logged_in_watcher='logged_in_watcher' :is_logged_in="is_logged_in" :is_checkout="is_checkout" :is_outlet="is_outlet"/>

            <div class="main-body">
                <Banner v-show='show_banner' :list_type="list_type"/>
                <router-view :key="$route.fullPath" class="page-content" @updatedCartListener='updatedCartListener' @LoginListener='LoginListener' :popstate_event='popstate_event'/>
            </div>

            <Footer v-show='show_footer'/>
        </div>

        <div v-if='route == "admin_control_panel"' class='admin-control-panel-container'>
            <AdminSideBar v-show='show_admin_side_bar' v-if="admin_logged_in" :page_name='page_name' :menu_expanded='admin_side_menu_expanded' @selectedMenuOptionListener="getPageTitle"/>
            <div class='admin-control-inner-wrapper'>
                <AdminTopBar v-show='show_admin_top_bar' v-if="admin_logged_in" :admin_user_info="admin_user_info" :page_title="page_title"/>
                <div class="admin-control-panel-body" :class="{'body-no-padding' : !show_admin_side_bar}">
                    <router-view :key="$route.fullPath" class="page-content"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import Header from '@/ecom/components/navigation/Header'
	import Footer from '@/ecom/components/footer/Footer'
    import Banner from '@/ecom/components/navigation/Banner.vue';
    import AdminSideBar from '@/ecom_cms/components/navigation/AdminSideBar.vue';
    import AdminTopBar from '@/ecom_cms/components/navigation/AdminTopBar.vue';
    import {checkAuth, setMetaTags, formatUrlForCachedFiles} from "@/global/modules/functions.js";
    
    export default {
        name: 'App',
        components : {Header, Footer, Banner, AdminSideBar, AdminTopBar},
        data() {
            return {
                updated_cart_watcher: null,
                show_top_navigation: true,
                show_footer: true,
                route: 'itim_shop',
                admin_logged_in: false,
                admin_user_info: null,
                page_title: '',
                page_name: '',
                admin_side_menu_expanded: true,
                popstate_event: null,
                show_admin_top_bar: true,
                show_admin_side_bar: true,
                show_banner: false,
                is_logged_in: false,
                logged_in_watcher: null,
                is_checkout: false,
                is_outlet: false,
                list_type: ''
            }
        },
        methods:{
            updatedCartListener(){
                this.updated_cart_watcher = +new Date();
                localStorage.setItem('updated_cart_watcher', this.updated_cart_watcher);
            },
            LoginListener() {
                this.checkUserLoggedIn();
            },
            setTheme(theme){
                document.documentElement.className = theme;
            },
            async checkAdminAccessTemp() {
                let response = await fetch(`/api/admin-access-check-temp`, {
                    method: 'GET',
                    credentials: 'include'
                });

                let results = await checkAuth(response);
                
                if (response.status === 200){
                    if(!results){
                        window.location.href = '/';
                    }
                }
            },
            async checkAdminAccess() {
                let response = await fetch(`/api/admin-access-check`, {
                    method: 'GET',
                    credentials: 'include'
                });

                let results = await checkAuth(response);
                
                if (response.status === 200){
                    this.admin_logged_in = results.is_logged_in;
                    this.admin_user_info = results;
                }
            },
            getPageTitle(title) {
                this.page_title = title;
            },
            async trackOtherPages(to) {
                try{
                    let formatted_route = formatUrlForCachedFiles(to.path);
                    const response = await fetch(`/cached_routes/${formatted_route}.json`);

                    if (!response.ok){
                        throw new Error('Route not found');
                    }

                    const route = await response.json();
                    if(route.type == 'plp' || route.type == 'pdp'){
                        this.show_banner = true;
                    }
                    return;
                }
                catch(e){
           
                }
            },
            async checkUserLoggedIn(){
                let response = await fetch(`/api/user/check-logged-in`, {
                    method: 'GET',
                    credentials: 'include'
                });

                let results = await checkAuth(response);
                
                if (response.status === 200){

                    if(!results){
                        this.is_logged_in = false;
                    }
                    else{
                        this.is_logged_in = true;
                    }
                    this.logged_in_watcher = +new Date();
                }
            },
        },
        watch: {
            $route(to, from) {
                // window.scrollTo(0,0);
                let pages = ['Product', 'Products'];
                if(!pages.includes(to.name)) {
                    const canonical_url = window.location.origin + to.path;
                    const meta_title  = to.meta.title != null ? 'Majestic Commercial | ' + to.meta.title : 'Majestic Commercial';
                    setMetaTags(meta_title, 'Majestic Commercial', '', canonical_url);
                }
                
                this.show_header = true;
                let hide_header = ['AdminControlPanel'];
                let hide_top_banner = ['AdminControlPanel'];
  
                if (hide_header.includes(to.name)) {
                    this.show_top_navigation = false;
                    this.show_footer = false;
                }

                if (hide_top_banner.includes(to.name)) {
                    this.show_top_navigation = false;
                    this.show_footer = false;
                }

                if(to.path.includes('/admin/')) {
                    this.page_name = to.name;

                    if(to.name == 'Page Builder'){ //On page builder auto shrink sidebar
                        this.admin_side_menu_expanded = false;
                        this.show_admin_top_bar = false;
                        this.show_admin_side_bar = false;
                    }
                    else{
                         this.admin_side_menu_expanded = true;
                        this.show_admin_top_bar = true;
                        this.show_admin_side_bar = true;
                    }

                }

                this.is_checkout = false;
                if(to.name == 'Checkout') {
                    this.is_checkout = true;
                }

                this.is_outlet = false;
                if(to.name == 'Outlets') {
                    this.is_outlet = true;
                }

                if(!to.path.includes('/admin/')) {
                    this.show_banner = false;
                    if(to.query.list_type == "customer_list") {
                        this.show_banner = true;
                        this.list_type = 'customer_list';
                    } else {
                        this.list_type = '';
                        this.trackOtherPages(to);
                    }
                }
            }
        },
        beforeMount() {
            window.onpopstate = (event) =>{ //Loading page from a back button event
                this.popstate_event = event;
                if(event){
                    return;
                }
            }

            if(window.location.pathname.includes("/admin/")){
                this.setTheme('admin');
                this.route = 'admin_control_panel';
                this.checkAdminAccessTemp();
            } 
            else{
                this.setTheme('itim_shop');
            }
        },
        mounted() {
            this.checkAdminAccess();
            this.checkUserLoggedIn();
        },
    }
</script>

<style lang="scss">
.itim-shop-container{
    display: flex;
    flex-direction: column;
    // position: relative;
    // z-index: 1;
}

.main-body {
    // z-index: -1; //All content -1 index so fixed header appears on top
	min-height: calc(100vh - var(--top-nav-bar-height) - var(--desktop-menu-container-height) - var(--footer-height)); //push footer down to bottom of page
    margin-top: calc(var(--top-nav-bar-height) + var(--desktop-menu-container-height) + var(--demo-banner-message-height)); //Offset body to take into account header
    overflow-x: clip; //Hide scroll bar x without adding an extra y scrollbar
    @media (max-width: 768px) {
        margin-top: calc(var(--top-nav-bar-height));
    }
}

.admin-control-panel-container{
    display: flex;
    background-color: var(--background-colour);
    overflow-x: clip;
    font-family: var(--cms-font-family);
}

.admin-control-panel-body{
    padding: 0px 30px;
    flex-grow: 1;
}

.admin-control-panel-body.body-no-padding{
    padding: 0px !important;
}

.admin-control-inner-wrapper{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
</style>